import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { LoadingPane } from '../common';
import * as touchpointsActions from './touchpoints.actions';
import { Title } from '../layout';
import RecentTouchpointResponseSummary from './recent-touchpoint-response-summary';

export class RecentTouchpointResponseComponent extends Component {
  constructor(props) {
    super(props);
    this.viewResponse = this.viewResponse.bind(this);
  }

  componentDidMount() {
    const { touchpointsActions, match } = this.props;
    const { params } = match;
    const { touchpointId } = params;

    if ( touchpointId ) {
      touchpointsActions.fetchTouchpointResponses( touchpointId,
          10, //maxRecords - fetchAll takes priority over this
          1,  //page - to get the most recent ones, take the first page
          5, // per page
          true, // fetch all, so that we know how many total responses there are.
          'date', // sort by date...
          false); // ...descending
      }
  }

  componentWillUpdate(nextProps, nextState) {
    const { touchpointsActions, match } = this.props;
    const { params } = match;
    const { touchpointId } = params;

    const nextTouchpointId = nextProps.params && nextProps.params.touchpointId;

    // Only fetch touchpoint responses if siteId, programId, and touchpointId are not null,
    // and at least one of them has changed from its previous value.
    if ( nextTouchpointId !== null && nextTouchpointId !== touchpointId ) {
      touchpointsActions.fetchTouchpointResponses( nextTouchpointId,
          10, //maxRecords - fetchAll takes priority over this
          1,  //page - to get the most recent ones, take the first page
          5, // per page
          true,  // fetch all, so that we know how many total responses there are.
          'date',  // sort by date...
          false);  // descending.
      }
  }

  viewResponse( item ) {
    const { touchpointsActions } = this.props;
    const programInformation = item.programs && item.programs.length > 0 ? item.programs[0] : {};
    touchpointsActions.redirectTo('sites/' + programInformation.siteId + '/programs/' + programInformation.programId + '/forms/' + item.formId + '/responses/' + item.id + '/view');
  }

render() {

    const { touchpoints, match } = this.props;
    const { params } = match;
    const { touchpointId } = params;
    const touchpointResponseState = touchpoints.pagedFormResponses && touchpoints.pagedFormResponses.get(touchpointId);
    const isLoading = !!touchpointResponseState && touchpointResponseState.isFetching;
    const err = touchpointResponseState && touchpointResponseState.err;
    const responses = touchpointResponseState && touchpointResponseState.responses;
    const totalResults = responses && responses.totalResults;
    const results = responses && responses.results;
    const visibleResults = 5;  // Default value per PP-50; can be changed or fetched from somewhere else in the future
    return ( results != null ?
      <div>
        <Title title="Recent Form Responses"/>
        <LoadingPane id="fetchLoadingPane" isLoading={isLoading} err={err}>
          <h4 className="page-header">
            {"Recent Form Responses"}
          </h4>
          <RecentTouchpointResponseSummary id="nested-content" results={results} visibleResults={visibleResults} viewResponse={this.viewResponse}/>
        </LoadingPane >
        { totalResults > visibleResults ?
          <Link to={`/responses/list`}
              className="btn btn-primary"
              role="button">
              View All { totalResults }
            </Link>
          :
          null
        }
      </div> :
      null
    );

  }

} // class

RecentTouchpointResponseComponent.propTypes = {
  touchpointsActions: PropTypes.object,
  touchpoints: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      touchpointId: PropTypes.isRequired
    })
  })
};

const mapDispatchToProps = (dispatch) => {
  return {
    touchpointsActions: bindActionCreators(touchpointsActions, dispatch)
  }
}

const mapStateToProps = ({ touchpoints }) => {
  return {
    touchpoints
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecentTouchpointResponseComponent);




// WEBPACK FOOTER //
// src/touchpoints/recent-touchpoint-response-component.js